import type { ServerGenerationAccess } from '@/lib/generationAccess';

/** No approved ad integration exists. Keep the placement inert, including for
 * Free users. Loading/private-content placements require policy and consent
 * review before connecting a real provider. Never show a fake ad block.
 */
export default function GenerationAdvertisement(_props: {
  access: ServerGenerationAccess | null;
  isDark: boolean;
}) {
  return null;
}
